import { Link } from "react-router-dom";
import { PenNib, PenNibStraight, GraduationCap, Stamp, ArrowRight, Check } from "@phosphor-icons/react";
import { Reveal, Eyebrow, MaskLines } from "../components/Motion";
import { SERVICES } from "../constants/site";

const ICONS = { PenNib, PenNibStraight, GraduationCap, Stamp };

export default function Services() {
  return (
    <div className="pt-36 sm:pt-44">
      <section className="max-w-[1440px] mx-auto px-5 sm:px-8">
        <Eyebrow>What we offer</Eyebrow>
        <h1 className="font-display font-light leading-[0.95] text-[clamp(3rem,9vw,8rem)] text-[color:var(--text)] mt-5">
          <MaskLines lines={["Our", "Services"]} delay={0.15} />
        </h1>
        <Reveal delay={0.3}>
          <p className="max-w-2xl text-[color:var(--text-2)] text-lg mt-8 leading-relaxed">
            Four disciplines, one studio. Whether it's a wedding programme, a career-defining résumé,
            a research paper or a licence application — every piece is handled with precision and care.
          </p>
        </Reveal>
      </section>

      <section className="max-w-[1440px] mx-auto px-5 sm:px-8 py-24 sm:py-32 space-y-24 sm:space-y-32">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.key} delay={0.05}>
              <div
                data-testid={`service-detail-${s.key}`}
                className="group grid lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-16 items-start border-t hairline pt-12"
              >
                <div className="lg:sticky lg:top-32">
                  <div className="flex items-center gap-5">
                    <span className="font-mono-x text-sm text-[color:var(--gold)]">{s.num}</span>
                    <div className="h-14 w-14 rounded-full border hairline flex items-center justify-center text-[color:var(--gold)] transition-colors duration-500 group-hover:border-[color:var(--gold)]">
                      {Icon && <Icon size={26} weight="light" />}
                    </div>
                  </div>
                  <h2 className="font-display text-5xl sm:text-6xl text-[color:var(--text)] mt-6">{s.title}</h2>
                  <p className="text-[color:var(--text-2)] mt-5 leading-relaxed max-w-md">{s.blurb}</p>
                </div>

                <ul className="grid sm:grid-cols-2 gap-x-10 gap-y-1">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-center gap-4 py-4 border-b hairline group/item">
                      <Check size={16} className="text-[color:var(--gold)] shrink-0" weight="bold" />
                      <span className="text-[color:var(--text)] text-lg transition-transform duration-500 group-hover/item:translate-x-1">{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </section>

      <section className="border-t hairline">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 py-24 text-center">
          <Reveal>
            <h2 className="font-display font-light text-5xl sm:text-6xl text-[color:var(--text)]">
              Don't see it listed? <span className="italic text-gradient-gold">Just ask.</span>
            </h2>
            <Link
              to="/contact"
              data-testid="services-cta"
              className="group inline-flex items-center gap-3 mt-10 rounded-full bg-[color:var(--gold)] px-9 py-4 text-[#0b0710] font-medium transition-all duration-500 hover:bg-[color:var(--gold-light)]"
            >
              Request a Quote
              <ArrowRight className="transition-transform duration-500 group-hover:translate-x-1" size={18} weight="bold" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
